type BreakpointKey = 'xs' | 'sm' | 'md' | 'mdplus' | 'lg' | 'xsDesktop' | 'desktop' | 'wide' | 'xl' | 'ultraWide'

interface Breakpoints {
    breakpoints: {
        values: Record<BreakpointKey, number>
    },
    up: (key: BreakpointKey) => string
    down: (key: BreakpointKey) => string
}

export const breakpoints: Breakpoints = {
    breakpoints: {
        values: {
            xs: 0,
            sm: 568,
            md: 768,
            mdplus: 960,
            lg: 1024,
            xsDesktop: 1280,
            desktop: 1440,
            wide: 1920,
            xl: 2560,
            ultraWide: 3840
        }
    },
    up: (key: BreakpointKey) => `@media (min-width:${breakpoints.breakpoints.values[key]}px)`,
    down: (key: BreakpointKey) => `@media (max-width:${breakpoints.breakpoints.values[key]}px)`
}